var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcRejectedByVisitor({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1016 1.25C5.22656 1.25 1.35156 5.125 1.35156 10C1.35156 14.875 5.22656 18.75 10.1016 18.75C14.9766 18.75 18.8516 14.875 18.8516 10C18.8516 5.125 14.9766 1.25 10.1016 1.25ZM10.1016 17.5C5.97656 17.5 2.60156 14.125 2.60156 10C2.60156 5.875 5.97656 2.5 10.1016 2.5C14.2266 2.5 17.6016 5.875 17.6016 10C17.6016 14.125 14.2266 17.5 10.1016 17.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4766 14.375L10.1016 11L6.72656 14.375L5.72656 13.375L9.10156 10L5.72656 6.625L6.72656 5.625L10.1016 9L13.4766 5.625L14.4766 6.625L11.1016 10L14.4766 13.375L13.4766 14.375Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcRejectedByVisitor);
export default __webpack_public_path__ + "static/media/ic-rejected-by-visitor.55295484bd8b45d139e3b9d1e5f562b3.svg";
export { ForwardRef as ReactComponent };